import { useReadSportPlayerBaseInfo } from './useReadSportPlayerBaseInfo';

export const useIsForcedSubtitles = (contentId: string) => {
    const baseInfo = useReadSportPlayerBaseInfo(contentId);

    return baseInfo?.onlineStreams?.playerRestrictionConfig?.subtitlesButtonEnable === false;
};
